import { memo, useCallback, FC } from 'react';
import { useDispatch } from 'react-redux';

import { CrossOutlinedSize16 } from '@hh.ru/magritte-ui/icon';
import { IconLink, IconVerticalAlignment } from 'bloko/blocks/icon';

import { removeItem } from 'src/api/price/cart';
import BlokoIconReplaceContainer from 'src/components/BlokoIconReplaceContainer';
import { useNotification } from 'src/components/Notifications/Provider';

import styles from './remove-button.less';

interface RemoveButtonProps {
    itemId: string;
    onClick?: () => void;
}

const RemoveButton: FC<RemoveButtonProps> = ({ itemId, onClick }) => {
    const dispatch = useDispatch();
    const { addNotification } = useNotification();

    const handleClick = useCallback(() => {
        void dispatch(removeItem(itemId, addNotification));
        onClick?.();
    }, [dispatch, itemId, onClick, addNotification]);

    return (
        <div className={styles.removeButton}>
            <IconVerticalAlignment>
                <IconLink onClick={handleClick} data-qa="cart-item__button-remove">
                    <BlokoIconReplaceContainer>
                        <CrossOutlinedSize16 initialColor="secondary" />
                    </BlokoIconReplaceContainer>
                </IconLink>
            </IconVerticalAlignment>
        </div>
    );
};

export default memo(RemoveButton);
